import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import PhoneOutline from './phone-outline-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <PhoneOutline {...validProps} />;
}

SvgComponent.iconName = 'phoneOutline';

export const PhoneOutlineIcon = svgIconWrapper(SvgComponent);
